module.exports = __webpack_public_path__ + "assets/icon-money-round-bg.52a726f3.svg";